<template>
    <button :type="type" :class="[isLoading ? 'is-loading' : '']" :disabled="disabled" :style="isLoading ? 'pointer-events: none' : ''">
        <slot></slot>
    </button>
</template>

<script>
    export default {
        name: "loading-button",
        props: ["isLoading", "disabled", "type"],
    };
</script>

<style scoped></style>
